import { AdminLayout } from '@/components/Layout';
import { usePagination } from '@/hooks/usePagination';
import HelpTable from '../../components/HelpTable';

export const HelpSupport = () => {
  const { page, changePage } = usePagination();

  return (
    <AdminLayout title="">
      <HelpTable page={page} changePage={changePage} />
    </AdminLayout>
  );
};
